export default class Booking {
    /**
     * Create new booking.
     */
    constructor() {
        this.lines = [];
        this.send_sms = false;
        this.preferred_zone = null;
    }

    /**
     * Get lines with quantity.
     *
     * @return {Object[]}
     */
    get linesWithQuantity() {
        let lines = [];

        for (let line of this.lines) {
            if (+line.quantity <= 0) {
                continue;
            }

            lines.push(line);
        }

        return lines;
    }

    /**
     * Get total quantity of lockers for this booking.
     *
     * @return {Number}
     */
    get totalLockers() {
        let total = 0;
        for (let line of this.lines) {
            total += +line.quantity;
        }

        return total;
    }

    /**
     * Calculate total amount.
     *
     * @param {Object} event
     * @return Number
     */
    calculateTotalAmount(event = null) {
        if (this.token) {
            // Existing booking, use amount from API
            return this.amount;
        }

        if (this.linesWithQuantity.length === 0) {
            return 0;
        }

        let amount = this.period.service_fee;

        for (let line of this.linesWithQuantity) {
            amount += line.quantity * line.price;
        }

        if (this.send_sms && event) {
            amount += event.sms_price;
        }

        return amount;
    }

    /**
     * Total quantity of lines.
     * @returns {number}
     */
    totalQuantity(){
        let total = 0;

        for (let line of this.linesWithQuantity) {
            total += line.quantity;
        }

        return total;
    }

    /**
     * Is this booking free?
     * @returns {boolean}
     */
    isFree() {
        return this.calculateTotalAmount() === 0;
    }

    /**
     * Set lines for the locker sizes of the period.
     *
     * @param {Object[]} lockerSizes
     * @param {Object[]} prices
     */
    setLinesForLockerSizes(lockerSizes, prices) {
        this.lines = [];

        for (let lockerSize of lockerSizes) {
            let price = prices.find(p => p.id === lockerSize.id);

            if (typeof price === 'undefined') {
                continue;
            }

            this.lines.push({
                'locker_size_id': lockerSize.id,
                'quantity': 0,
                'name': lockerSize.name,
                'description': lockerSize.description,
                'price': price.price,
                'available': price.available
            });
        }
    }

    /**
     * Reset period and quantities of this booking.
     */
    reset() {
        this.period = null;
        this.period_id = null;

        for (let line of this.lines) {
            line.quantity = 0;
        }
    }
}
